import { render, staticRenderFns } from "./EntityDetailsHeader.vue?vue&type=template&id=c0a688b6&scoped=true"
import script from "./EntityDetailsHeader.vue?vue&type=script&lang=js"
export * from "./EntityDetailsHeader.vue?vue&type=script&lang=js"
import style0 from "./EntityDetailsHeader.vue?vue&type=style&index=0&id=c0a688b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a688b6",
  null
  
)

export default component.exports